import * as React from 'react';
import { Link } from 'react-router-dom';

import styles from './table-row.module.css';

interface TableRowProps {
    id?: string | number;
    rowWrapper: 'link' | 'div';
    linkTarget?: string;
    children: React.ReactNode;
}

function TableRow({ id, children, rowWrapper, linkTarget = '' }: TableRowProps): React.ReactElement<TableRowProps> {
    if (rowWrapper === 'div')
        return (
            <div className={styles.TableRow} data-qa="table row" id={`tablerow-${id}`}>
                {children}
            </div>
        );

    return (
        <Link to={linkTarget} className={styles.TableRow} data-qa="table-row-link">
            {children}
        </Link>
    );
}

export default TableRow;
